import type { ImgHTMLAttributes } from "react";
import { imageSrcSet, optimizeImage } from "@/lib/images";
import { cn } from "@/lib/utils";

type SmartImageProps = Omit<ImgHTMLAttributes<HTMLImageElement>, "src" | "srcSet" | "width" | "height"> & {
  src: string;
  width: number;
  height: number;
  priority?: boolean;
  cdnWidth?: number;
};

export function SmartImage({
  src,
  alt,
  width,
  height,
  priority = false,
  cdnWidth,
  className,
  sizes,
  loading,
  fetchPriority,
  decoding,
  ...rest
}: SmartImageProps) {
  const target = cdnWidth ?? (priority ? 800 : width >= 700 ? 800 : width >= 200 ? 400 : 160);
  const widths = target >= 700 ? [400, 800, 1200] : target >= 300 ? [200, 400, 800] : [80, 160];

  return (
    <img
      src={optimizeImage(src, target)}
      srcSet={imageSrcSet(src, widths)}
      sizes={sizes ?? (priority ? "(max-width: 768px) 92vw, 36rem" : "(max-width: 640px) 50vw, 280px")}
      alt={alt ?? ""}
      width={width}
      height={height}
      className={cn(className)}
      {...rest}
      loading={priority ? "eager" : (loading ?? "lazy")}
      fetchPriority={priority ? "high" : (fetchPriority ?? "low")}
      decoding={decoding ?? "async"}
    />
  );
}
